import dayjs from "dayjs";
import * as Yup from "yup";

export const validationSchema = (t) =>
  Yup.object().shape({
    subject: Yup.string()
      .max(50, t("messages.MSG-USP052", { number: 50 }))
      .required(),
    content: Yup.string()
      .required()
      .test((value, context) => {
        const regex = new RegExp('<figure class="image">', "g");
        if (value?.match(regex)?.length > 3) {
          return context.createError({
            path: context.path,
            message: t("messages.MSG-USP093"),
          });
        }

        return true;
      }),
    content_no_html: Yup.string().max(
      5000,
      t("messages.MSG-USP052", { number: 5000 })
    ),
    date: Yup.date()
      .nullable()
      // .test((value, context) => {
      //   if (validateTime(value, context?.parent?.time)) {
      //     return context.createError({
      //       path: context.path,
      //       message: t("messages.MSG-USP094"),
      //     });
      //   }
      //   return true;
      // })
      ,
    time: Yup.date()
      .nullable()
      // .test((value, context) => {
      //   if (validateTime(context?.parent?.date, value)) {
      //     return context.createError({
      //       path: context.path,
      //       message: t("messages.MSG-USP094"),
      //     });
      //   }
      //   return true;
      // }),
  });

// const validateTime = (date, time) => {
//   if (!date || !time) return;
//   const currentDatetime = dayjs(date)
//     .set("hour", time.getHours())
//     .set("minutes", time.getMinutes())
//     .set("second", 0);

//   if (dayjs().startOf("minute").diff(currentDatetime) > 0) {
//     return true;
//   }

//   return false;
// };
